import * as VKID from '@vkid/sdk';

// Переменная означает: если true - НЕ ПРОДАКШН
// облать применения: всё что связано с безопасностью. Вывод токенов в консоль и т.д.
// Default value in prod: FALSE
export const SECURITY_NO_PROD = true

// Базовая составляющая ссылок к API, контракт: в конце слэш обязателен.
export const API_BASE_URL = "https://vstuhelper.fazziclay.com/api/v1/"

// Ссылка открывающаяся в новой вкладке при нажатии на "УСТАНОВИТЬ РАСШИРЕНИЕ"
export const INSTALL_EXTENSION_URL = "https://www.google.com"

// Ссылка для личного кабинета
// TODO: мне кажется нужно чтобы не в новой вкладке открывался а на этой же, убрать _blank ~fazziclay
export const PERSONAL_CABINET_URL = "/personal"

// Иммитировать вход в систему
export const USE_FAKE_ACCOUNT = false;

// Иммитировать купленную подписку
export const USE_FAKE_SUB = false;

// PKCE (codeVerifier or codeChallenge) будет добавлено в соотстветствии с кодом
// state также будет добавлен.
export const VK_CONFIG = {
    app: 53862241,
    redirectUrl: 'https://vstuhelper.fazziclay.com/api/v1/vklogin/nad-nim-ne-bylo-nichego-uzhe-krome-neba-vysokogo-neba-ne-yasnogo-no-vse-taki-neizmerimo-vysokogo',
    mode: VKID.ConfigAuthMode.InNewTab,
    responseMode: VKID.ConfigResponseMode.Callback,
    scope: 'user_id',
}